
import { all, put, takeLatest } from 'redux-saga/effects';
import * as baseTypes from './base/types';
import * as summaryTypes from './summary/types';
import * as diagnosticTypes from './diagnostics/types';
import * as types from './types';

import { sagas as baseSagas } from './base';
import { sagas as summarySagas } from './summary';
import { sagas as diagnosticSagas } from './diagnostics';
import { sagas as sensitivitySagas } from './sensitivityControl';

function* init() {
  yield all([
    put({ type: baseTypes.INIT }),
    put({ type: summaryTypes.INIT }),
    put({ type: diagnosticTypes.INIT }),
  ]);
}

function* watchReset() {
  yield takeLatest([
    types.RESET,
  ], init);
}

export default [
  init,
  watchReset,
  ...baseSagas,
  ...summarySagas,
  ...diagnosticSagas,
  ...sensitivitySagas
];
